// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Header UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
:root {
  /* Variable ezAlphaBackgroundWhite2 from ez-body.css */
  --ezPublicHeaderBackgroundColor: var(--ezAlphaBackgroundWhite2);
  --ezHeaderBackgroundColor: var(--ezAlphaBackgroundWhite2);
  /* Variables for fonts from ez-text.css */
  --ezPublicHeaderFontColor: var(--ezBannerHeaderColor);
  --ezPublicHeaderFontFamily: var(--ezFontFamily);
  --ezPublicHeaderFontSize: var(--ezBannerHeaderFontSize);
  --ezPublicHeaderFontWeight: var(--ezBannerHeaderFontWeight);
  --ezHeaderFontColor: var(--ezBannerHeaderColor);
  --ezHeaderFontFamily: var(--ezFontFamily);
  --ezHeaderFontSize: var(--ezBannerHeaderFontSize);
  --ezHeaderFontWeight: var(--ezBannerHeaderFontWeight);
  /* Variables for fonts from ez-text.css */
  --ezPublicSubHeaderFontColor: var(--ezTitleFontColor);
  --ezPublicSubHeaderFontSize: var(--ezHeaderFontSize);
  --ezSubHeaderFontColor: var(--ezTitleFontColor);
  --ezSubHeaderFontSize: var(--ezHeaderFontSize);
  /* Variables for borders from ez-borders.css */
  --ezPublicHeaderBorderColor: var(--ezBorderColorBlack);
  --ezPublicHeaderBorderStyle: var(--ezBorderStyle);
  --ezPublicHeaderBorderSize: var(--ezBorderWidth);
  --ezHeaderBorderColor: var(--ezBorderColorBlack);
}

/* -------------------------------------------------------------------
| Desktop Screen Styles (default)                                   |
------------------------------------------------------------------- */
app-header {
  background-color: var(--ezHeaderBackgroundColor);
  --app-header-background-rear-layer: {
      /* The header is blue when condensed */
      background-color: blue;
  };
  --app-header-shadow: {
          box-shadow: inset 0 5px 2px -3px rgb(0 0 0 / 20%) ;
  } ;
}

.ezHeader-mobile {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: min-content;
  align-content: stretch;
  padding: 8px;
  /* Background variable from ez-header.css :root (this file) */
  background-color: var(--ezClockerWhite);
  /* Font variables from ez-header.css :root (this file) */
  color: var(--ezPublicHeaderFontColor);
  font-family: var(--ezPublicHeaderFontFamily);
  font-size: var(--ezPublicHeaderFontSize);
  font-weight: var(--ezPublicHeaderFontWeight);
}

/* Public page header */
.ezHeader-public {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: min-content;
  padding: 8px;
  /* Background variable from ez-header.css :root (this file) */
  background-color: var(--ezPublicHeaderBackgroundColor);
  /* Font variables from ez-header.css :root (this file) */
  color: var(--ezPublicHeaderFontColor);
  font-family: var(--ezPublicHeaderFontFamily);
  font-size: var(--ezPublicHeaderFontSize);
  font-weight: var(--ezPublicHeaderFontWeight);
  /* Border variables from ez-header.css :root (this file) */
  border-bottom-color: var(--ezPublicHeaderBorderColor);
  border-bottom-style: var(--ezPublicHeaderBorderStyle);
  border-bottom-width: var(--ezPublicHeaderBorderSize);
  box-shadow: 0 2px 2px 0 rgb(109 110 112/50%);
  transition: 200ms ease-in-out;
  transform-origin: center top;
  transform: none;
}

.ezHeader-public-logo {
  min-height: 62px;
  padding: 4px;
  /* Background variable from ez-header.css :root (this file) */
  background-color: var(--ezPublicHeaderBackgroundColor);
  background-image: url("/public/images/logos/ezclocker_logo_2015.svg");
  background-position-x: left;
  background-position-y: center;
  background-repeat: no-repeat;
  background-size: 250px;
  background-clip: content-box;
  /* Font variables from ez-header.css :root (this file) */
  color: var(--ezPublicHeaderFontColor);
  font-family: var(--ezPublicHeaderFontFamily);
  font-size: var(--ezPublicHeaderFontSize);
  font-weight: var(--ezPublicHeaderFontWeight);
  /* Border variables from ez-header.css :root (this file) */
  border-bottom-color: var(--ezPublicHeaderBorderColor);
  border-bottom-style: var(--ezPublicHeaderBorderStyle);
  border-bottom-width: var(--ezPublicHeaderBorderSize);
  box-shadow: 0 2px 2px 0 rgb(109 110 112/50%);
  transition: 200ms ease-in-out;
  transform-origin: center top;
  transform: none;
}

.ezHeader-public-ezclocker-logo-container {
  display: grid;
  grid-template-columns: min-content auto;
  justify-content: start;
  align-content: center;
}

.ezHeader-public-ezclocker-logo-image-container {
  display: grid;
  margin-right: 8px;
  align-content: center;
  justify-content: start;
}

.ezHeader-public-ezclocker-logo-image {
  max-width: 250px;
  padding: 0;
  margin: 0;
  margin-right: 8px;
  border-style: none;
}

/* Secure page header */
.ezHeader {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: min-content;
  padding-top: 4px;
  padding-left: 6px;
  padding-right: 6px;
  padding-bottom: 4px;
  background-color: rgb(255 255 255/40%);
  color: var(--ezClockerBlack);
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
  border-bottom-color: var(--ezClockerBlack);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  box-shadow: 0 2px 2px 0 rgb(109 110 112/50%);
}

/* Secure page header */
.ezHeader-fixed {
  display: grid;
  position: sticky;
  grid-template-columns: auto auto;
  grid-template-rows: min-content;
  padding-left: 4px;
  padding-right: 4px;
  background-color: rgb(255 255 255/40%);
  color: var(--ezClockerBlack);
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
  border-bottom-color: var(--ezClockerBlack);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  box-shadow: 0 2px 2px 0 rgb(109 110 112/50%);
}

.ezHeader-employer-logo-container {
  display: grid;
  grid-template-columns: min-content auto;
  justify-content: start;
  align-content: center;
}

.ezHeader-logo-image-container {
  display: grid;
  margin-right: 8px;
  align-content: center;
  justify-content: start;
}

.ezHeader-employer-logo {
  margin: 0;
  max-width: 110px;
  max-height: 40px;
  font-size: 8px;
}

.ezHeader-employer-name {
  display: grid;
  align-content: center;
  justify-content: start;
  border-style: none;
  /* Variables from ez-text.css */
  color: var(--ezBannerHeaderColor);
  font-family: var(--ezFontFamily);
  font-weight: var(--ezBannerHeaderFontWeight);
  font-size: var(--ezBannerHeaderFontSize);
}

.ezHeader-navigation-button-container {
  display: grid;
  grid-auto-flow: column;
  column-gap: 4px;
  justify-content: end;
  align-content: center;
}

img.ez-header-employer-logo-spinner {
  padding: 2px;
  border-style: none;
  vertical-align: middle;
  max-width: 110px;
  max-height: 40px;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  margin-right: 10px;
}

div.ez-header-employer-name-text {
  font-size: 18pt;
  font-weight: bold;
}

div.ez-header-page-name-text {
  color: var(--ezClockerBlack);
  font-size: 12pt;
}

.ezPageHeader {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 8px;
  background-color: rgb(255 255 255/40%);
  color: var(--ezClockerBlack);
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
  border-bottom-color: var(--ezClockerBlack);
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.ezPageHeader-ezClockerWhite {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-family: Roboto, Verdana, sans-serif;
  font-weight: normal;
  font-size: 32pt;
  border-bottom-color: var(--ezClockerBlack);
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.ezPageHeaderLogo {
  max-width: 250px;
  border-style: none;
  padding: 8px;
  margin: 0;
  vertical-align: middle;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}
*/
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {
}
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-header.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAIA;EACI,sDAAA;EACA,+DAAA;EACA,yDAAA;EAEA,yCAAA;EACA,qDAAA;EACA,+CAAA;EACA,uDAAA;EACA,2DAAA;EACA,+CAAA;EACA,yCAAA;EACA,iDAAA;EACA,qDAAA;EAEA,yCAAA;EACA,qDAAA;EACA,oDAAA;EACA,+CAAA;EACA,8CAAA;EAEA,8CAAA;EACA,sDAAA;EACA,iDAAA;EACA,gDAAA;EACA,gDAAA;AAFJ;;AAKA;;qEAAA;AAGA;EACI,gDAAA;EAEA;;;GAAA;EAKA;;IAAA;AAFJ;;AAOA;EACI,aAAA;EACA,gCAAA;EACA,+BAAA;EACA,sBAAA;EACA,YAAA;EAEA,6DAAA;EACA,uCAAA;EAEA,wDAAA;EACA,qCAAA;EACA,4CAAA;EACA,wCAAA;EACA,4CAAA;AANJ;;AASA,uBAAA;AACA;EACI,aAAA;EACA,gCAAA;EACA,+BAAA;EACA,YAAA;EAGA,6DAAA;EACA,sDAAA;EAEA,wDAAA;EACA,qCAAA;EACA,4CAAA;EACA,wCAAA;EACA,4CAAA;EAEA,0DAAA;EACA,qDAAA;EACA,qDAAA;EACA,oDAAA;EACA,4CAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,YAAA;EAEA,6DAAA;EACA,sDAAA;EACA,qEAAA;EACA,2BAAA;EACA,6BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EAEA,wDAAA;EACA,qCAAA;EACA,4CAAA;EACA,wCAAA;EACA,4CAAA;EAEA,0DAAA;EACA,qDAAA;EACA,qDAAA;EACA,oDAAA;EACA,4CAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,uCAAA;EACA,sBAAA;EACA,qBAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAbJ;;AAgBA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;AAbJ;;AAgBA,uBAAA;AACA;EACI,aAAA;EACA,gCAAA;EACA,+BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sCAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,0BAAA;EACA,wBAAA;EACA,4CAAA;AAbJ;;AAgBA,uBAAA;AACA;EACI,aAAA;EACA,gBAAA;EACA,gCAAA;EACA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,0BAAA;EACA,wBAAA;EACA,4CAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,uCAAA;EACA,sBAAA;EACA,qBAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAbJ;;AAgBA;EACI,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,+BAAA;EACA,iCAAA;EACA,gCAAA;EACA,4CAAA;EACA,wCAAA;AAdJ;;AAiBA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,eAAA;EACA,iBAAA;AAdJ;;AAiBA;EACI,4BAAA;EACA,eAAA;AAdJ;;AAiBA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sCAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,0BAAA;EACA,wBAAA;AAdJ;;AAiBA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,0BAAA;EACA,wBAAA;AAdJ;;AAiBA;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;AAdJ;;AAiBA;;qEAAA;AAGA;;;CAAA;AAMA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Header UX CSS Classes\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n:root {\n    /* Variable ezAlphaBackgroundWhite2 from ez-body.css */\n    --ezPublicHeaderBackgroundColor: var(--ezAlphaBackgroundWhite2);\n    --ezHeaderBackgroundColor: var(--ezAlphaBackgroundWhite2);\n\n    /* Variables for fonts from ez-text.css */\n    --ezPublicHeaderFontColor: var(--ezBannerHeaderColor);\n    --ezPublicHeaderFontFamily: var(--ezFontFamily);\n    --ezPublicHeaderFontSize: var(--ezBannerHeaderFontSize);\n    --ezPublicHeaderFontWeight: var(--ezBannerHeaderFontWeight);\n    --ezHeaderFontColor: var(--ezBannerHeaderColor);\n    --ezHeaderFontFamily: var(--ezFontFamily);\n    --ezHeaderFontSize: var(--ezBannerHeaderFontSize);\n    --ezHeaderFontWeight: var(--ezBannerHeaderFontWeight);\n\n    /* Variables for fonts from ez-text.css */\n    --ezPublicSubHeaderFontColor: var(--ezTitleFontColor);\n    --ezPublicSubHeaderFontSize: var(--ezHeaderFontSize);\n    --ezSubHeaderFontColor: var(--ezTitleFontColor);\n    --ezSubHeaderFontSize: var(--ezHeaderFontSize);\n\n    /* Variables for borders from ez-borders.css */\n    --ezPublicHeaderBorderColor: var(--ezBorderColorBlack);\n    --ezPublicHeaderBorderStyle: var(--ezBorderStyle);\n    --ezPublicHeaderBorderSize: var(--ezBorderWidth);\n    --ezHeaderBorderColor: var(--ezBorderColorBlack);\n}\n\n/* -------------------------------------------------------------------\n| Desktop Screen Styles (default)                                   |\n------------------------------------------------------------------- */\napp-header {\n    background-color: var(--ezHeaderBackgroundColor);\n\n    --app-header-background-rear-layer: {\n        /* The header is blue when condensed */\n        background-color: blue;\n    };\n\n    --app-header-shadow: {\n            box-shadow: inset 0 5px 2px -3px rgb(0 0 0 / 20%) ;\n    }\n}\n\n.ezHeader-mobile {\n    display: grid;\n    grid-template-columns: auto auto;\n    grid-template-rows: min-content;\n    align-content: stretch;\n    padding: 8px;\n\n    /* Background variable from ez-header.css :root (this file) */\n    background-color: var(--ezClockerWhite);\n\n    /* Font variables from ez-header.css :root (this file) */\n    color: var(--ezPublicHeaderFontColor);\n    font-family: var(--ezPublicHeaderFontFamily);\n    font-size: var(--ezPublicHeaderFontSize);\n    font-weight: var(--ezPublicHeaderFontWeight);\n}\n\n/* Public page header */\n.ezHeader-public {\n    display: grid;\n    grid-template-columns: auto auto;\n    grid-template-rows: min-content;\n    padding: 8px;\n\n\n    /* Background variable from ez-header.css :root (this file) */\n    background-color: var(--ezPublicHeaderBackgroundColor);\n\n    /* Font variables from ez-header.css :root (this file) */\n    color: var(--ezPublicHeaderFontColor);\n    font-family: var(--ezPublicHeaderFontFamily);\n    font-size: var(--ezPublicHeaderFontSize);\n    font-weight: var(--ezPublicHeaderFontWeight);\n\n    /* Border variables from ez-header.css :root (this file) */\n    border-bottom-color: var(--ezPublicHeaderBorderColor);\n    border-bottom-style: var(--ezPublicHeaderBorderStyle);\n    border-bottom-width: var(--ezPublicHeaderBorderSize);\n    box-shadow: 0 2px 2px 0 rgb(109 110 112 / 50%);\n    transition: 200ms ease-in-out;\n    transform-origin: center top;\n    transform: none;\n}\n\n.ezHeader-public-logo {\n    min-height: 62px;\n    padding: 4px;\n\n    /* Background variable from ez-header.css :root (this file) */\n    background-color: var(--ezPublicHeaderBackgroundColor);\n    background-image: url('/public/images/logos/ezclocker_logo_2015.svg');\n    background-position-x: left;\n    background-position-y: center;\n    background-repeat: no-repeat;\n    background-size: 250px;\n    background-clip: content-box;\n\n    /* Font variables from ez-header.css :root (this file) */\n    color: var(--ezPublicHeaderFontColor);\n    font-family: var(--ezPublicHeaderFontFamily);\n    font-size: var(--ezPublicHeaderFontSize);\n    font-weight: var(--ezPublicHeaderFontWeight);\n\n    /* Border variables from ez-header.css :root (this file) */\n    border-bottom-color: var(--ezPublicHeaderBorderColor);\n    border-bottom-style: var(--ezPublicHeaderBorderStyle);\n    border-bottom-width: var(--ezPublicHeaderBorderSize);\n    box-shadow: 0 2px 2px 0 rgb(109 110 112 / 50%);\n    transition: 200ms ease-in-out;\n    transform-origin: center top;\n    transform: none;\n}\n\n.ezHeader-public-ezclocker-logo-container {\n    display: grid;\n    grid-template-columns: min-content auto;\n    justify-content: start;\n    align-content: center;\n}\n\n.ezHeader-public-ezclocker-logo-image-container {\n    display: grid;\n    margin-right: 8px;\n    align-content: center;\n    justify-content: start;\n}\n\n.ezHeader-public-ezclocker-logo-image {\n    max-width: 250px;\n    padding: 0;\n    margin: 0;\n    margin-right: 8px;\n    border-style: none;\n}\n\n/* Secure page header */\n.ezHeader {\n    display: grid;\n    grid-template-columns: auto auto;\n    grid-template-rows: min-content;\n    padding-top: 4px;\n    padding-left: 6px;\n    padding-right: 6px;\n    padding-bottom: 4px;\n    background-color: rgb(255 255 255 / 40%);\n    color: var(--ezClockerBlack);\n    font-family: Roboto, Verdana, sans-serif;\n    font-weight: normal;\n    font-size: 32pt;\n    border-bottom-color: var(--ezClockerBlack);\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n    box-shadow: 0 2px 2px 0 rgb(109 110 112 / 50%);\n}\n\n/* Secure page header */\n.ezHeader-fixed {\n    display: grid;\n    position: sticky;\n    grid-template-columns: auto auto;\n    grid-template-rows: min-content;\n    padding-left: 4px;\n    padding-right: 4px;\n    background-color: rgb(255 255 255 / 40%);\n    color: var(--ezClockerBlack);\n    font-family: Roboto, Verdana, sans-serif;\n    font-weight: normal;\n    font-size: 32pt;\n    border-bottom-color: var(--ezClockerBlack);\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n    box-shadow: 0 2px 2px 0 rgb(109 110 112 / 50%);\n}\n\n.ezHeader-employer-logo-container {\n    display: grid;\n    grid-template-columns: min-content auto;\n    justify-content: start;\n    align-content: center;\n}\n\n.ezHeader-logo-image-container {\n    display: grid;\n    margin-right: 8px;\n    align-content: center;\n    justify-content: start;\n}\n\n.ezHeader-employer-logo {\n    margin: 0;\n    max-width: 110px;\n    max-height: 40px;\n    font-size: 8px;\n}\n\n.ezHeader-employer-name {\n    display: grid;\n    align-content: center;\n    justify-content:start;\n    border-style: none;\n\n    /* Variables from ez-text.css */\n    color: var(--ezBannerHeaderColor);\n    font-family: var(--ezFontFamily);\n    font-weight: var(--ezBannerHeaderFontWeight);\n    font-size: var(--ezBannerHeaderFontSize);\n}\n\n.ezHeader-navigation-button-container {\n    display: grid;\n    grid-auto-flow: column;\n    column-gap: 4px;\n    justify-content: end;\n    align-content: center;\n}\n\nimg.ez-header-employer-logo-spinner {\n    padding: 2px;\n    border-style: none;\n    vertical-align: middle;\n    max-width: 110px;\n    max-height: 40px;\n    border-top-right-radius: 4px;\n    border-top-left-radius: 4px;\n    margin-right: 10px;\n}\n\ndiv.ez-header-employer-name-text {\n    font-size: 18pt;\n    font-weight: bold;\n}\n\ndiv.ez-header-page-name-text {\n    color: var(--ezClockerBlack);;\n    font-size: 12pt;\n}\n\n.ezPageHeader {\n    padding-left: 4px;\n    padding-right: 4px;\n    padding-bottom: 8px;\n    background-color: rgb(255 255 255 / 40%);\n    color: var(--ezClockerBlack);;\n    font-family: Roboto, Verdana, sans-serif;\n    font-weight: normal;\n    font-size: 32pt;\n    border-bottom-color: var(--ezClockerBlack);;\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n}\n\n.ezPageHeader-ezClockerWhite {\n    padding-left: 4px;\n    padding-right: 4px;\n    padding-bottom: 8px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);;\n    font-family: Roboto, Verdana, sans-serif;\n    font-weight: normal;\n    font-size: 32pt;\n    border-bottom-color: var(--ezClockerBlack);;\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n}\n\n.ezPageHeaderLogo {\n    max-width: 250px;\n    border-style: none;\n    padding: 8px;\n    margin: 0;\n    vertical-align: middle;\n}\n\n/* -------------------------------------------------------------------\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 1023px) {\n}\n*/\n\n\n/* -------------------------------------------------------------------\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 768px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 480px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 319px) {\n}\n*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
